import React from "react";

import {useConfirmationModalContext} from "../../../../../../../../../../components/ConfirmationModalContextProvider";


const useCancelSelection = ({hasSelectedAssets, handleClose, handleNextClick}) => {
  const modalContext = useConfirmationModalContext();

  return async () => {
    if (hasSelectedAssets) {
      const confirmResult = await modalContext.confirm({
        message: 'Wollen Sie Ihre Änderungen speichern?',
        confirmButtonText: "Ja, speichern",
        rejectButtonText: "Nein, verwerfen",
        title: 'Nicht gespeicherte Änderungen',
        variant: 'danger'
      });

      if (confirmResult === false) {
        handleClose();
      } else if (confirmResult === true) {
        handleNextClick()
      }
    } else {
      handleClose();
    }
  };
}

export default useCancelSelection;